import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import styled from "styled-components";
import { entitiestext } from "variables/MBM/connectivity.js";
import { equipmenttext } from "variables/MBM/equipments.js";
import { mbmcriticityData } from "variables/lists/patrimoine";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import ReactLoading from "react-loading";
import ViewEquipmentAlarmsDialog from "components/MBM/EquipmentAlarms/ViewEquipmentAlarmsDialog.js";
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import SignalCellularAlt2BarIcon from '@mui/icons-material/SignalCellularAlt2Bar';
import SignalCellularAlt1BarIcon from '@mui/icons-material/SignalCellularAlt1Bar';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CheckSharpIcon from '@mui/icons-material/CheckSharp';
import useEntitiesTable from "./useEntitiesTable.js";

const Container = styled.div`
  border: solid;
  border-width: 1px;
  border-color: #EEEEEE;
  background-color: white;
  margin-top: -0.5px;
  padding-top: 5px;
  overflow-x: auto;
  width: 100%;
`;
const EllipsisCellText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const LoadingDiv = styled.div`
height: 20vh;
width: 20vw;
display: flex;
justify-content: center;
padding-top: 0vh;
flex-direction: column;
align-items: center;
`;

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTEntities = () => {
  const { gridState, refetch, setSites, sitesdata } = useEntitiesTable();
  const [entitiesalarmsdata, setEntitiesalarmsdata] = useState([]);
  const [refreshAlarms, setRefreshAlarms] = useState(true);
  const [alertopen, setAlertopen] = useState(false);

  const handleRefreshAlarms = () => {
    setRefreshAlarms(true);
  }
  const classes = useStyles();

  const getBatteryStyle = (batterylevel) => {
    if (batterylevel) {
      if (batterylevel < 50) {
        return { color: "#f44336" };
      }
      else if (batterylevel < 75) {
        return { color: "#FF763A" };
      }
      else {
        return { color: "#000000" };
      }
    }
  }
  const getTemperatureStyle = (temperature) => {
    if (temperature) {
      if (temperature < 19) {
        return { color: "#3E8FC6" };
      }
      else if (temperature > 25) {
        return { color: "#FF763A" };
      }
      else {
        return { color: "#91c241" };
      }
    }
  }
  const handleClickAlertOpen = () => {
    setAlertopen(true);
  };
  const handleClickAlertClose = () => {
    setAlertopen(false);
  };
  const openalert = (row) => async () => {
    let alarms = row.alarms?.alarms;
    if (alarms) {
      setEntitiesalarmsdata(alarms);
      handleClickAlertOpen();
    }
  };

  const entitiescolumns = [
    {
      name: entitiestext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: entitiestext.path,
      selector: (row) => row.path,
      sortable: true,
      width: "10rem",
      cell: (row) => row.path ? <Tooltip title={row.path.replace('-> ', '')}><EllipsisCellText>{row.path.replace('-> ', '')}</EllipsisCellText></Tooltip> : '',
    },
    {
      name: entitiestext.criticiy,
      selector: (row) => row.mbm?.criticity ? row.mbm.criticity : 0,
      sortable: true,
      width: "6rem",
      cell: (row) => row.mbm?.criticity ? mbmcriticityData.find((a) => a.id == row.mbm?.criticity)?.name || "" : "",
    },
    {
      name: entitiestext.alarms,
      selector: (row) => row.alarms?.alarms?.find((al) => (al.closed === 0 && !(al.acquitment?.acquited === "yes"))) ? 2
        : row.alarms?.alarms?.find((al) => (al.closed === 0 && !(al.acquitment?.acquited === "yes"))) ? 1
          : 0,
      sortable: true,
      maxWidth: "5rem",
      cell: (row) => <div style={{ cursor: 'pointer' }} onClick={openalert(row)}>{
        row.alarms?.alarms?.find((al) => (al.closed === 0 && !(al.acquitment?.acquited === "yes"))) ?
          <Tooltip title={equipmenttext.activealarms}><NotificationsActiveIcon sx={{ color: "#f44336" }} fontSize="medium" /></Tooltip>
          : row.alarms?.alarms?.find((al) => (al.closed === 0 && !(al.acquitment?.acquited === "yes"))) ?
            <Tooltip title={equipmenttext.nonacquitedalarms}><NotificationsIcon sx={{ color: "#FF763A" }} fontSize="medium" /></Tooltip>
            : <Tooltip title={equipmenttext.noalarms}><CheckSharpIcon sx={{ color: "#91c241" }} fontSize="medium" /></Tooltip>
      }</div>
    },
    {
      name: entitiestext.connectedequipments,
      selector: (row) => (row.dashboard.equipmentsactives + row.dashboard.equipmentsinactives) > 0 ? (row.dashboard.equipmentsactives / (row.dashboard.equipmentsactives + row.dashboard.equipmentsinactives)) : 0,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => row.dashboard.equipmentsactives + '/' + (row.dashboard.equipmentsactives + row.dashboard.equipmentsinactives)
    },
    {
      name: entitiestext.connectedmediumequipments,
      selector: (row) => (row.dashboard.equipmentsmediumactives + row.dashboard.equipmentsmediuminactives) > 0 ? (row.dashboard.equipmentsmediumactives / (row.dashboard.equipmentsmediumactives + row.dashboard.equipmentsmediuminactives)) : 0,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => row.dashboard.equipmentsmediumactives + '/' + (row.dashboard.equipmentsmediumactives + row.dashboard.equipmentsmediuminactives)
    },
    {
      name: entitiestext.connectedhighequipments,
      selector: (row) => (row.dashboard.equipmentshighactives + row.dashboard.equipmentshighinactives) > 0 ? (row.dashboard.equipmentshighactives / (row.dashboard.equipmentshighactives + row.dashboard.equipmentshighinactives)) : 0,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => row.dashboard.equipmentshighactives + '/' + (row.dashboard.equipmentshighactives + row.dashboard.equipmentshighinactives)
    },
    {
      name: entitiestext.minbattery,
      selector: (row) => (row.dashboard.minbattery != null) ? row.dashboard.minbattery : -1000,
      sortable: true,
      maxWidth: "6rem",
      minWidth: "4rem",
      cell: (row) => (row.dashboard.minbattery != null) ? <div style={getBatteryStyle(row.dashboard.minbattery)}>{new Intl.NumberFormat('fr-FR').format(row.dashboard.minbattery) + '%'}</div> : "",
    },
    {
      name: entitiestext.avgbattery,
      selector: (row) => (row.dashboard.avgbattery != null) ? row.dashboard.avgbattery : -1000,
      sortable: true,
      maxWidth: "6rem",
      minWidth: "4rem",
      cell: (row) => (row.dashboard.avgbattery != null) ? <div style={getBatteryStyle(row.dashboard.avgbattery)}>{new Intl.NumberFormat('fr-FR').format(row.dashboard.avgbattery) + '%'}</div> : "",
    },
    {
      name: entitiestext.minsignal,
      selector: (row) => (row.dashboard.minsignal != null) ? row.dashboard.minsignal : -1000,
      sortable: true,
      maxWidth: "6rem",
      minWidth: "4rem",
      cell: (row) => {
        let display = "";
        if (row.dashboard.minsignal != null) {
          if (row.dashboard.minsignal >= 0) {
            display = <Tooltip title={row.dashboard.minsignal + " db"}><SignalCellularAltIcon sx={{ color: "#91c241" }} fontSize="medium" /></Tooltip>;
          }
          else if (row.dashboard.minsignal >= -10) {
            display = <Tooltip title={row.dashboard.minsignal + " db"}><SignalCellularAlt2BarIcon sx={{ color: "#FF763A" }} fontSize="medium" /></Tooltip>;
          }
          else {
            display = <Tooltip title={row.dashboard.minsignal + " db"}><SignalCellularAlt1BarIcon sx={{ color: "#f44336" }} fontSize="medium" /></Tooltip>;
          }
        }
        return display;
      }
    },
    {
      name: entitiestext.avgsignal,
      selector: (row) => (row.dashboard.avgsignal != null) ? row.dashboard.avgsignal != null : -1000,
      sortable: true,
      maxWidth: "6rem",
      minWidth: "4rem",
      cell: (row) => {
        let display = "";
        if (row.dashboard.avgsignal != null) {
          if (row.dashboard.avgsignal >= 0) {
            display = <Tooltip title={new Intl.NumberFormat('fr-FR').format(row.dashboard.avgsignal) + " db"}><SignalCellularAltIcon sx={{ color: "#91c241" }} fontSize="medium" /></Tooltip>;
          }
          else if (row.dashboard.avgsignal >= -10) {
            display = <Tooltip title={new Intl.NumberFormat('fr-FR').format(row.dashboard.avgsignal) + " db"}><SignalCellularAlt2BarIcon sx={{ color: "#FF763A" }} fontSize="medium" /></Tooltip>;
          }
          else {
            display = <Tooltip title={new Intl.NumberFormat('fr-FR').format(row.dashboard.avgsignal) + " db"}><SignalCellularAlt1BarIcon sx={{ color: "#f44336" }} fontSize="medium" /></Tooltip>;
          }
        }
        return display;
      }
    },
    {
      name: entitiestext.mintemp,
      selector: (row) => row.dashboard.mintemp || -1000,
      sortable: true,
      maxWidth: "5rem",
      minWidth: "4rem",
      cell: (row) => row.dashboard.mintemp ? <div style={getTemperatureStyle(row.dashboard.mintemp)}>{new Intl.NumberFormat('fr-FR').format(row.dashboard.mintemp) + '°c'}</div> : "",
    },
    {
      name: entitiestext.avgtemp,
      selector: (row) => row.dashboard.avgtemp || -1000,
      sortable: true,
      maxWidth: "5rem",
      minWidth: "4rem",
      cell: (row) => row.dashboard.avgtemp ? <div style={getTemperatureStyle(row.dashboard.avgtemp)}>{new Intl.NumberFormat('fr-FR').format(row.dashboard.avgtemp) + '°c'}</div> : "",
    },
    {
      name: entitiestext.maxtemp,
      selector: (row) => row.dashboard.maxtemp || -1000,
      sortable: true,
      maxWidth: "5rem",
      minWidth: "4rem",
      cell: (row) => row.dashboard.maxtemp ? <div style={getTemperatureStyle(row.dashboard.maxtemp)}>{new Intl.NumberFormat('fr-FR').format(row.dashboard.maxtemp) + '°c'}</div> : "",
    },
  ];



  const ExpandableComponent = props => {
    const { data } = props;
    //const datadisplay = pointsdata.filter((x) => x.equipment === data.id);

    return (
      <Container>
        {/* <DataTable
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          noDataComponent={<NoData>Aucun Point à afficher</NoData>}
          noHeader={true}
          columns={pointscolumns}
          persistTableHead
          data={datadisplay}
          striped={true}
        /> */}
      </Container>
    );
  };


  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setSites(selection.selectedRows);
  };


  return (
    <>
      <DataTable
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        noDataComponent={<NoData>Aucun site à afficher</NoData>}
        noHeader={true}
        columns={entitiescolumns}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<div><LoadingDiv>{entitiestext.loadingdata}<ReactLoading
          type={"bars"}
          color={"#91c241"}
          height={"10%"}
          width={"10%"}
        /></LoadingDiv></div>}
        // expandOnRowClicked={displaymethod === 'equipments'}
        // expandableRows={displaymethod === 'equipments'}
        // expandableRowDisabled={(row) => row.disabled}
        // expandableRowsComponent={ExpandableComponent}
        // conditionalRowStyles={displaymethod === 'equipments' ? conditionalRowStylesGroup : conditionalRowStylesPoints}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />

      <Dialog
        onClose={handleClickAlertClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        inputProps={{
          name: 'max-width',
          id: 'max-width',
        }}
        maxWidth="xl"
        open={alertopen}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleClickAlertClose}>
          {equipmenttext.alarms}
        </CustomDialogTitle>
        <DialogContent dividers>
          <ViewEquipmentAlarmsDialog
            alarmsdata={entitiesalarmsdata}
            closeModal={handleClickAlertClose}
            refetch={handleRefreshAlarms}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTEntities;
